import React, { FC, PropsWithChildren, useEffect, useId, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

import Logo from '../Logo';
import menu from '../../static/images/open_burger_menu.svg';
import SocialList from '../SocialList';
import Navigation from '../Navigation';
import useScrollOut from '../../hooks/useScrollOut';
import LanguageSelector from '../LanguageSelector';
import CurrencySelector from '../CurrencySelector';

import Drawer from './Drawer';
import { Wrapper, LogoWrapper, Phone, BurgerOpenButton, Content, RightGroup } from './styles';

const Header: FC<PropsWithChildren> = ({ children }) => {
  const [isOpenDrawer, setIsOpenDrawer] = useState(false);
  const [canCloseDrawer, setCanCloseDrawer] = useState(false);
  const openButtonRef = useRef<HTMLButtonElement | null>(null);
  const closeTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const drawerId = useId();

  const isInsideDrawer = !!children;

  const isScrolledOut = useScrollOut(10, !isInsideDrawer);

  useEffect(() => {
    if (isOpenDrawer) return;
    setCanCloseDrawer(false);
  }, [isOpenDrawer]);

  useEffect(() => () => {
    if (closeTimerRef.current) clearTimeout(closeTimerRef.current);
  }, []);

  const handelCloseDrawer = () => {
    if (closeTimerRef.current) return;
    setCanCloseDrawer(true);
    closeTimerRef.current = setTimeout(() => {
      setIsOpenDrawer(false);
      closeTimerRef.current = null;
      openButtonRef.current?.focus();
    }, 500);
  };

  return (
    <Wrapper className={isScrolledOut ? 'shadow' : ''}>
      <Content>
        <LogoWrapper>
          <Logo />
        </LogoWrapper>
        <Navigation />
        <RightGroup>
          <SocialList />
          <CurrencySelector />
          <LanguageSelector />
        </RightGroup>
        {children || (
          <BurgerOpenButton
            ref={openButtonRef}
            type="button"
            aria-label="Open menu"
            aria-haspopup="dialog"
            aria-expanded={isOpenDrawer}
            aria-controls={isOpenDrawer ? drawerId : undefined}
            onClick={() => setIsOpenDrawer(true)}
          >
            <img src={menu} alt="" aria-hidden="true" />
          </BurgerOpenButton>
        )}
        {isOpenDrawer && createPortal(
          <Drawer id={drawerId} canOpen={isOpenDrawer} canClose={canCloseDrawer} onClose={handelCloseDrawer} />,
          document.body
        )}
      </Content>
    </Wrapper>
  );
};

export default Header;
